<template>
  <div>
    <el-dialog title="提交" :visible.sync="submitVisible" width="468" center
               :before-close="beforeClose">
      <!-- <span>需要注意的是内容是默认不居中的</span> -->
      <!-- <div class="left">
        <slot name="title">默认标题</slot>
      </div> -->
      <div class="content-body">
        有句段译文为空，不可提交。
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancle">跳转到该句子</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'submitDialog',
  props: {
    submitVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },
  methods: {
    beforeClose() {
      this.$emit('beforeClose')
    },
    handleCancle() {
      this.$emit('jumpSentence')
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  margin-top: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 468px;
  height: 224px;
  .el-dialog__header {
    padding: 25px 30px 0 30px;
    line-height: 0;
    text-align: left;
    .el-dialog__title {
      font-weight: 600;
      color: #333;
      font-size: 16px;
    }
    .el-dialog__headerbtn {
      top: 22px;
      right: 27px;
      .el-dialog__close {
        font-size: 20px;
      }
    }
  }
  .el-dialog__body {
    padding: 25px 30px 0 30px;
    .content-body {
      text-align: center;
      font-size: 14px;
      height: 60px;
    }
  }
  .el-dialog__footer {
    .dialog-footer {
      .el-button + .el-button {
        margin-left: 30px;
      }
    }
  }
}
</style>